import { useEffect, useReducer } from "react";

/**
 * Re-render the component every interval. By default, it re-renders every second.
 */
export const useIntervalRerender = (intervalMs = 1000) => {
  const [, forceRender] = useReducer((c: number) => c + 1, 0);

  useEffect(() => {
    const intervalId = window.setInterval(forceRender, intervalMs);

    return () => {
      clearInterval(intervalId);
    };
  }, [forceRender, intervalMs]);
};
